<ng-container *ngIf="competency">
  <app-preview-leveled-competency
    [competency]="competency"
    [rubricId]="topicId" />
</ng-container>
